module.exports = {
      id: "phone-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }